import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import SubmitButton from "../SubmitButton";
import { useApp } from "../../contexts/AppContext";
import { useApi } from "../../contexts/ApiContext";

interface SignoutDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[5],
  },
}));

const SignoutDialog: React.FC<SignoutDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { translate } = useApp();
  const translations = translate("auth").signoutDialog;

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      aria-labelledby="logout-dialog-title"
      aria-describedby="logout-dialog-description"
    >
      <DialogTitle id="logout-dialog-title">{translations.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="logout-dialog-description">
          {translations.caption}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="whiteButton">
          {translations.buttons.cancel}
        </Button>
        <SubmitButton onClick={onConfirm} color="blackButton">
          {translations.buttons.signout}
        </SubmitButton>
      </DialogActions>
    </StyledDialog>
  );
};

export default SignoutDialog;
